import React from 'react';

import QueryString from 'qs';
import { Link } from 'react-router-dom';

import { Alert, Button } from '@mui/material';

import { OFFER_METRICS_TABS } from '../PromoDisplayConfig/OfferMetricsContainer';

type PromoConfigLinkProps = {
  promoDisplayConfigId?: string;
  type: 'results' | 'check';
};

const PromoDisplayConfigLink = ({ promoDisplayConfigId, type }: PromoConfigLinkProps) => {
  switch (type) {
    case 'results':
      return (
        <Link
          to={`/marketing/offer-metrics?${QueryString.stringify({
            tab: OFFER_METRICS_TABS.PROMO_DISPLAY_CHECK_RESULTS,
            promoDisplayConfigId,
          })}`}
          target="_blank"
          rel="noreferrer"
          color="inherit"
        >
          <Button variant="outlined" fullWidth>
            Results
          </Button>
        </Link>
      );
    case 'check':
      return (
        <Link
          to={`/marketing/offer-metrics?${QueryString.stringify({
            tab: OFFER_METRICS_TABS.PROMO_DISPLAY_CHECK,
            promoDisplayConfigId,
          })}`}
          target="_blank"
          rel="noreferrer"
          color="inherit"
        >
          <Button variant="outlined" fullWidth>
            Check
          </Button>
        </Link>
      );
    default:
      return <Alert severity="error">Invalid type</Alert>;
  }
};

export default PromoDisplayConfigLink;
